import React from "react";
import { Grid, Typography } from "@mui/material";
import { SIGNUP_COLORS, SIGNUP_TYPOGRAPHY } from "../../../tokens";

interface StepHeaderProps {
  title: string;
  subtitle: string;
  variant?: "default" | "step5";
}

const StepHeader: React.FC<StepHeaderProps> = ({ title, subtitle, variant = "default" }) => {
  const isStep5 = variant === "step5";

  return (
    <Grid item xs={12} sx={{ mb: "24px" }}>
      <Typography
        color={SIGNUP_COLORS.textPrimary}
        fontFamily={SIGNUP_TYPOGRAPHY.fontFamily}
        fontWeight={isStep5 ? 700 : SIGNUP_TYPOGRAPHY.title.fontWeight}
        fontSize={isStep5 ? "28px" : SIGNUP_TYPOGRAPHY.title.fontSize}
        lineHeight={isStep5 ? "36px" : SIGNUP_TYPOGRAPHY.title.lineHeight}
        sx={{ mb: "12px" }}
      >
        {title}
      </Typography>
      <Typography
        color={SIGNUP_COLORS.gray600}
        fontFamily={SIGNUP_TYPOGRAPHY.fontFamily}
        fontWeight={SIGNUP_TYPOGRAPHY.subtitle.fontWeight}
        fontSize={SIGNUP_TYPOGRAPHY.subtitle.fontSize}
        lineHeight={SIGNUP_TYPOGRAPHY.subtitle.lineHeight}
      >
        {subtitle}
      </Typography>
    </Grid>
  );
};

export default StepHeader;
